export default {
  "version": {
    "update_tips": "更新提示",
    "update_text": "当前有新版本，是否更新？",
    "update_now": "现在更新",
    "update_later": "稍后更新"
  }
}